import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../_metronic/layout";
import { StudentFamilyBranchList } from "./StudentFamilyBranchList";
import { StudentFamilyBranchProvider } from "./components/StudentFamilyBranchContext";

export default function StudentFamilyBranchPage({ history }) {
  return (
    <StudentFamilyBranchProvider>
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect
          exact={true}
          from="/student-family-branch"
          to="/student-family-branch/list"
        />
        <ContentRoute
          path="/student-family-branch/list"
          component={StudentFamilyBranchList}
        />
      </Switch>
    </Suspense>
    </StudentFamilyBranchProvider>
  );
}